import classes from "./styles.module.scss";
import type { IErrorViewProps } from "./types";
import { RenderErrorContent } from "./renderErrorContent";

import errorImage from "@/assets/images/errorPageImage.svg";

export function ErrorView(props: IErrorViewProps) {
  const { errorCode } = props;

  return (
    <div className={classes.container}>
      <img
        src={errorImage}
        alt={`errorImage:${errorCode}`}
        className={classes.container__img}
      />
      <RenderErrorContent {...props} />
    </div>
  );
}
